module.exports = __webpack_public_path__ + "static/img/2.d12e18a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1314/2.png
// module id = 472
// module chunks = 1